/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ParentRegion
 */
export interface ParentRegion {
  /**
   * The unique identifier assigned by the system when a region is first created.
   * @type number
   * @memberof ParentRegion
   */
  regionsKey: number
  /**
   * The name assigned to the region.
   * @type string
   * @memberof ParentRegion
   */
  name: string
}

export function ParentRegionFromJSON(json: any): ParentRegion {
  return ParentRegionFromJSONTyped(json, false)
}

export function ParentRegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ParentRegion {
  if (json === undefined || json === null) {
    return json
  }
  return {
    regionsKey: json['regionsKey'],
    name: json['name'],
  }
}

export function ParentRegionToJSON(value?: ParentRegion | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    regionsKey: value.regionsKey,
    name: value.name,
  }
}
